// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"973a0d31","246":"eed95b40","420":"6b117e5a","455":"92adc002","537":"4d8e4f73","591":"3c95a31b","644":"6669910e","847":"a32ab2f8"}[chunkId] + ".chunk.js";
};